<template>
  <div id="OauthSso" class="bg-brand-secondary">
    <div
      class="d-flex flex-row align-items-center justify-content-center mx-auto container m-5"
    >
      <Loader v-if="!errorMessage" />
    </div>
  </div>
</template>

<script>
/**
 * This view is used to redirect the user to the returnUrl with the user_token.
 * Authentication page for OAuth SSO /authorize.
 *
 * TODO: In case user is not logged in, redirect to login page and after login redirect to returnUrl.
 */
import Loader from "@/components/Loader.vue";
import { buildSsoReturnUrl } from "@/utils/ssoReturnUrl/ssoReturnUrl";

export default {
  name: "OauthSso",
  components: {
    Loader,
  },
  data() {
    return {
      errorMessage: false,
    };
  },
  mounted() {
    const toBeReturnedUrl = this.$route.query.returnUrl;
    if (!toBeReturnedUrl) return;

    const authServerHost = process.env.VUE_APP_AUTHSERVER_PATH
      ? new URL(process.env.VUE_APP_AUTHSERVER_PATH).hostname
      : null;
    const extraHosts = [
      authServerHost,
      ...(process.env.VUE_APP_SSO_RETURN_HOSTS || "").split(","),
    ].filter(Boolean);
    const returnUrl = buildSsoReturnUrl(
      toBeReturnedUrl,
      this.$store.getters.user_id,
      window.location.hostname,
      extraHosts,
    );

    if (!returnUrl) {
      this.errorMessage = true;
      return;
    }
    window.location.href = returnUrl;
  },
};
</script>
<style lang="less">
#OauthSso {
  height: 100vh;
  display: flex;

  .error-message {
    width: 100%;
    padding: 45vh;
    text-align: center;
    font-size: 2.5rem;
    color: white;
  }
}
</style>
